export default  {
      position:'fixed',
      right:0,
      bottom:0,
      margin:'23px'
};



/** WEBPACK FOOTER **
 ** ./src/utils/right-corner-style.js
 **/